'use es6';

import { Record } from 'immutable';
import { cleanObject } from '../utils/formatters';
import uniqueId from 'hs-lodash/uniqueId';
export default class Screenshot extends Record({
  imageUrl: '',
  altText: '',
  id: ''
}) {
  constructor(values) {
    super(Object.assign({}, cleanObject(values), {
      id: uniqueId('screenshot-')
    }));
  } // 'id' is used as a unique key that persists as the record updates, for ListTransition


  equals(otherObj) {
    return this.delete('id').toString() === otherObj.delete('id').toString();
  }

}